export enum TableInfoType {
    Orders,
    Positions
}